<template>
  <div data-test="select-decision-type-wrapper">
    <label
      v-if="label"
      class="mb-2 block font-medium"
    >
      {{ label }}
    </label>
    <AutoComplete
      v-model="decision_type_name"
      :suggestions="decision_types_filtered"
      :disabled="is_disabled"
      optionLabel="attributes.name"
      :showClear="true"
      completeOnFocus
      inputClass="w-full"
      class="h-9 w-full"
      :placeholder="is_disabled ? $t('decision_type.validation.projectRequired') : placeholder"
      :pt="{
        pcInputText: {
          root: { 'data-test': 'select-decision-type' },
        },
      }"
      @complete="fetch_decision_types"
      @option-select="select_decision_type"
      @clear="clear_selection"
    >
      <template #empty>
        {{ $t('select.actions.noResults') }}
      </template>
    </AutoComplete>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import AutoComplete from 'primevue/autocomplete';

const props = defineProps({
  active: { type: Object, default: null },
  modelValue: { type: Object, default: null },
  project_id: { type: String, default: null },
  unit_id: { type: String, default: null },
  placeholder: { type: String, default: null },
  label: { type: String, default: null },
});

const emit = defineEmits(['changeSelect']);

const store = useStore();

const decision_type_name = ref('');

const selected_value = computed(() => props.modelValue || props.active);

watch(
  selected_value,
  (new_val) => {
    decision_type_name.value = _.get(new_val, 'attributes.name', '');
  },
  { immediate: true },
);

const decision_types = computed(() => store.getters.decision_types);

const decision_types_project = computed(() =>
  _.filter(decision_types.value, ['attributes.project_id', props.project_id]),
);

const decision_types_filtered = computed(() => {
  const query = typeof decision_type_name.value === 'string' ? decision_type_name.value.toLowerCase() : '';
  return _.filter(decision_types_project.value, (p) => p.attributes.name.toLowerCase().indexOf(query) >= 0);
});

const is_disabled = computed(() => _.isNil(props.project_id) && _.isNil(props.unit_id));

const fetch_decision_types = async () => {
  await store.dispatch('FETCH_DECISION_TYPES', { project_id: props.project_id });
};

const select_decision_type = (event) => {
  const selected = event?.value || null;
  emit('changeSelect', selected);
};

const clear_selection = () => {
  decision_type_name.value = '';
  emit('changeSelect', null);
};
</script>
